// extracted by mini-css-extract-plugin
module.exports = {"view":"_3dGQalfwMO42JQrrS_acot","categoryImg":"U5uLnd365pPdKJ8DIrAgB"};